
<template>
  <div>
    <IndexCard fluid :loading="isInitialLoading">
      <template slot="header">
        <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
        <v-col cols='8' md='10' centered tag="h1" class="white--text">
          Pagamento de frete
          <v-btn icon class="white" color="black" target="_blank" :to="{ name: 'PrintShipping' }"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
        <v-btn text icon large :disabled="loading.drivers" @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
      </template>
      <template slot="subheader">
        <div class="filters-toolbar">
          <v-row align="center" justify="center" dense>
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-chip-group
                v-model="filter"
                mandatory
                :disabled="loading.drivers"
                active-class="filters-toolbar__chip--active-primary"
                :class="['filters-toolbar__chips', { 'filters-toolbar__chips--disabled': loading.drivers }]"
              >
                <v-chip
                  v-for="option in mainFilterOptions"
                  :key="option.value"
                  :value="option.value"
                  pill
                  small
                  :disabled="loading.drivers"
                  class="filters-toolbar__chip"
                >
                  <v-icon left small>{{ option.icon }}</v-icon>
                  {{ option.label }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <v-expand-transition>
            <div v-if="filter === 'open_incomes'" class="filters-toolbar__receipt mt-2">
              <span class="filters-toolbar__receipt-label text-caption grey--text text--darken-1 d-block mb-1 text-center">
                Forma de recebimento
              </span>
              <div class="d-flex justify-center">
                <v-chip-group
                  v-model="filter_by_receipt"
                  mandatory
                  :disabled="loading.drivers"
                  active-class="filters-toolbar__chip--active-secondary"
                  :class="['filters-toolbar__chips', 'filters-toolbar__chips--receipt', { 'filters-toolbar__chips--disabled': loading.drivers }]"
                >
                <v-chip
                  v-for="option in receiptFilterOptions"
                  :key="option.value"
                  :value="option.value"
                  pill
                  small
                  :disabled="loading.drivers"
                  class="filters-toolbar__chip"
                >
                  <v-icon left small>{{ option.icon }}</v-icon>
                  {{ option.label }}
                </v-chip>
              </v-chip-group>
              </div>
            </div>
          </v-expand-transition>

          <v-row dense class="mt-2">
            <v-col cols="12">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Buscar motorista"
                outlined
                dense
                hide-details
                clearable
                class="filters-toolbar__search"
              />
            </v-col>
          </v-row>

          <v-progress-linear
            v-if="isRefreshing"
            indeterminate
            color="primary"
            class="filters-toolbar__progress mt-2"
            height="2"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-card elevation="3">
          <v-card-text class="pb-2 pt-0">
            <v-data-iterator
              :items="all_drivers_filtered"
              :search="search"
              :options="{ itemsPerPage: 16 }"
              :footer-props="{ 'items-per-page-options': [8, 16, 24, -1] }"
              class="pt-1"
            >
              <template v-slot:no-data>
                <v-alert v-if="activeModalityId < 0" :value="true" type="error" icon="mdi-alert" class="ma-3 mt-3">
                  <template>Selecione um modulo para filtrar os pagamentos</template>
                </v-alert>

                <v-alert v-else :value="true" type="info" icon="mdi-alert" class="ma-3 mt-3">
                  <template>Não há mais dados</template>
                </v-alert>

                <v-divider class="mt-3"></v-divider>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" type="error" icon="mdi-alert" class="ma-3">
                  Não foi encontrado nenhum resultado com "{{ search }}".
                </v-alert>
                <v-divider class="mt-3"></v-divider>
              </template>

              <template v-slot:default="props">
                <v-row wrap align="center" justify="start" class="mt-1">
                  <v-col cols="6" md="6" lg="3" v-for="item in props.items" :key="item.id">
                    <v-card style="border-radius: 8px; cursor: pointer" @click="showDriver(item)" elevation="0" outlined>
                      <v-card-title class="py-2">
                        <div class="d-flex flex-column">
                          <span class="subtitle-2">{{ item.name }}</span>
                        </div>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <div v-if="item.without_doc_count">
                          <v-chip color='error' class="white--text">
                            <v-avatar left class="error darken-2 mr-2 align-center text-center">
                              {{ item.without_doc_count }}
                            </v-avatar>
                            Sem comprovante
                          </v-chip>
                        </div>
                        <div v-if="item.open_incomes_count_by_brand?.length">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip v-on="on" color='grey lighten-2' class="black--text pl-2 mx-1" small>
                                <v-avatar left class="grey lighten-1">
                                  <v-icon small>mdi-currency-usd</v-icon>
                                </v-avatar>
                                {{
                                  item.open_incomes_count_by_brand.reduce((acc, one) => acc +
                                    Number(one.vt_ammount), 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                }}
                              </v-chip>
                            </template>
                            Valor total
                          </v-tooltip>
                          <v-tooltip top v-for="(ib) in item.open_incomes_count_by_brand"
                            :key="ib.brand_name + ib.vt_ammount + ib.vt_count">
                            <template v-slot:activator="{ on }">
                              <v-chip v-on="on" color='primary' class="white--text pl-2 mx-1" small>
                                <v-avatar left class="primary darken-2">
                                  {{ ib.vt_count || '' }}
                                </v-avatar>
                                {{ ib.brand_name || '' }}
                              </v-chip>
                            </template>
                            {{ Number(ib.vt_ammount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                          </v-tooltip>
                        </div>
                        <div v-if="item.vrt">
                          <v-chip color='primary' class="white--text ma-3 pr-5" pill>
                            <v-avatar left size="28" class="primary darken-2">
                              {{ item.vrt }}
                            </v-avatar>
                            Faturas abertas
                          </v-chip>
                        </div>
                        <div v-if="!driverHasPaymentInfo(item)">
                          <v-chip color="grey lighten-3" class="grey--text text--darken-2" small>
                            <v-icon left small>mdi-file-document-outline</v-icon>
                            Sem faturas abertas
                          </v-chip>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </template>
    </IndexCard>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index';

const MAIN_FILTER_OPTIONS = [
  { value: 'all', label: 'Ver todos', icon: 'mdi-view-grid' },
  { value: 'open_incomes', label: 'Com faturas', icon: 'mdi-file-document-outline' },
  { value: 'without_doc', label: 'Sem comprovantes', icon: 'mdi-file-alert-outline' },
]

const RECEIPT_FILTER_OPTIONS = [
  { value: 'all', label: 'Todos', icon: 'mdi-filter-variant' },
  { value: 'pix', label: 'Pix', icon: 'mdi-qrcode' },
  { value: 'deposit', label: 'Depósito', icon: 'mdi-bank' },
  { value: 'cash', label: 'Dinheiro', icon: 'mdi-cash' },
  { value: 'bill', label: 'Boleto', icon: 'mdi-barcode' },
]

export default {
  name: 'IndexPayShippings',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
  },
  data() {
    return {
      search: null,
      all_drivers: [],
      local_filter: {},
      filter: 'open_incomes',
      filter_by_receipt: 'deposit',
      mainFilterOptions: MAIN_FILTER_OPTIONS,
      receiptFilterOptions: RECEIPT_FILTER_OPTIONS,
      loading: {
        drivers: false,
      },
      driversRequestId: 0,
    }
  },
  computed: {
    ...mapState({
      activeModalitySolution: state => state.App.activeModalitySolution,
    }),
    isInitialLoading() {
      return this.loading.drivers && !this.all_drivers.length
    },
    isRefreshing() {
      return this.loading.drivers && this.all_drivers.length > 0
    },
    all_drivers_filtered() {
      if (!this.all_drivers.length) return []

      let drivers = [...this.all_drivers]

      if (this.filter === 'open_incomes') {
        if (this.activeModalitySolution === 'wholesale') {
          drivers = drivers.filter(driver => driver.open_incomes_count_by_brand?.length > 0)
          if (this.filter_by_receipt !== 'all') {
            drivers = drivers.filter(driver => this.driverMatchesReceiptKind(driver, this.filter_by_receipt))
          }
        }
        return this.sortWholesaleOpenIncomes(drivers)
      }

      if (this.filter === 'without_doc') {
        return drivers
      }

      return drivers
    },
  },
  methods: {
    getData() {
      this.getDriversBySolution()
    },
    getDriversBySolution() {
      if (this.activeModalityId < 0) return

      if (this.activeModalitySolution === 'wholesale') {
        this.getWholesaleDrivers()
      } else {
        this.getRetailDrivers()
      }
    },
    receiptKinds(driver) {
      const config = driver.transporter_receipt_config || driver.receipt_config || {}
      if (config.kinds?.length) return config.kinds
      if (config.kind) return [config.kind]
      return []
    },
    driverMatchesReceiptKind(driver, kind) {
      if (kind === 'all') return true
      return this.receiptKinds(driver).includes(kind)
    },
    sortWholesaleOpenIncomes(drivers) {
      if (this.activeModalitySolution !== 'wholesale' || this.filter !== 'open_incomes') {
        return drivers
      }

      return [...drivers]
        .sort((one, next) => {
          const nextCount = next.open_incomes_count_by_brand?.reduce((acc, item) => acc + Number(item.vt_count), 0) || 0
          const oneCount = one.open_incomes_count_by_brand?.reduce((acc, item) => acc + Number(item.vt_count), 0) || 0
          return nextCount - oneCount
        })
        .map(driver => ({
          ...driver,
          brand_names: driver.open_incomes_count_by_brand?.map(b => b.brand_name).join(', ') || '',
        }))
    },
    getWholesaleFilter() {
      const filter = { ...this.local_filter, financial: true, modality_ids: [this.activeModalityId] }

      if (this.filter === 'without_doc') {
        filter.without_doc = true
      }
      return filter
    },
    getWholesaleDrivers() {
      if (this.activeModalitySolution !== 'wholesale') return

      const requestId = ++this.driversRequestId
      this.loading.drivers = true
      const filter = this.getWholesaleFilter()

      Api.Driver.index({ ...filter, modality_id: this.activeModalityId })
        .then(r => r.data)
        .then(data => {
          if (requestId !== this.driversRequestId) return
          data = data.data ? data.data.map(ds => ds.attributes) : data
          this.all_drivers = [...data]
        })
        .catch(err => {
          if (requestId !== this.driversRequestId) return
          console.error(err)
        })
        .finally(() => {
          if (requestId !== this.driversRequestId) return
          this.loading.drivers = false
        })
    },
    getRetailFilter() {
      const filter = { ...this.local_filter, modality_id: this.activeModalityId }

      if (this.filter === 'open_incomes') {
        filter.with_open_shipping = true
        if (this.filter_by_receipt !== 'all') {
          filter.receipt_kind = this.filter_by_receipt
        }
      }
      if (this.filter === 'without_doc') {
        filter.without_doc = true
        filter.financial = true
      }
      return filter
    },
    getRetailDrivers() {
      if (this.activeModalitySolution !== 'retail') return

      const requestId = ++this.driversRequestId
      this.loading.drivers = true
      const filter = this.getRetailFilter()
      const apiModule = filter.without_doc ? 'Driver' : 'RetailPayDrivers'

      Api[apiModule].index(filter)
        .then(res => res.data)
        .then(data => {
          if (requestId !== this.driversRequestId) return
          data = data.data ? data.data.map(ds => ds.attributes) : data
          this.all_drivers = [...data]
        })
        .catch(err => {
          if (requestId !== this.driversRequestId) return
          console.error(err)
        })
        .finally(() => {
          if (requestId !== this.driversRequestId) return
          this.loading.drivers = false
        })
    },
    driverHasPaymentInfo(item) {
      return !!(item.without_doc_count || item.open_incomes_count_by_brand?.length || item.vrt)
    },
    showDriver(driver) {
      this.$router.push({ name: 'ShowDriverPayShipping', params: { id: driver.id, modality_id: this.activeModalityId } })
    },
  },

  mounted() {
    this.getData()
  },
  watch: {
    activeModalityId() {
      this.getDriversBySolution()
    },
    filter(nv, ov) {
      if (this.activeModalitySolution === 'wholesale' && nv !== 'without_doc' && ov !== 'without_doc') {
        return
      }
      this.getDriversBySolution()
    },
    filter_by_receipt() {
      if (this.filter === 'open_incomes' && this.activeModalitySolution === 'retail') {
        this.getDriversBySolution()
      }
    },
  },
}
</script>

<style scoped>
.filters-toolbar {
  width: 100%;
}

.filters-toolbar__search >>> .v-input__slot {
  border-radius: 8px !important;
  background-color: #fff;
}

.filters-toolbar__chips {
  flex-wrap: wrap;
  justify-content: center;
}

.filters-toolbar__chips--receipt {
  justify-content: center;
}

.filters-toolbar__chips--disabled {
  pointer-events: none;
  opacity: 0.6;
}

.filters-toolbar__progress {
  border-radius: 2px;
}

.filters-toolbar__chip {
  background-color: #f0f0f0 !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87) !important;
}

.filters-toolbar__chip >>> .v-icon {
  color: rgba(0, 0, 0, 0.6) !important;
}

.filters-toolbar__chip--active-primary {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
}

.filters-toolbar__chip--active-primary >>> .v-icon {
  color: #fff !important;
}

.filters-toolbar__chip--active-secondary {
  background-color: #424242 !important;
  border-color: #424242 !important;
  color: #fff !important;
}

.filters-toolbar__chip--active-secondary >>> .v-icon {
  color: #fff !important;
}

.filters-toolbar__search {
  width: 100%;
}
</style>
